<template>
  <a-col :span="24" :sm="11" :md="Math.floor(24 / length) - 1">
    <a-typography-text class="text-gray-8 fs-xl d-block">
      {{ formatNumber(total) }}
    </a-typography-text>
    <a-typography-text class="text-gray-8 fs-sm d-block">
      {{ title }}
    </a-typography-text>
  </a-col>
  <a-col :span="0" :sm="index % 2 === 0 ? 1 : 0" :md="1">
    <a-divider v-if="showSeparator" type="vertical" style="height: 48px" />
  </a-col>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Ingrese un titulo'
    },
    total: {
      type: [String, Number],
      default: 0
    },
    showSeparator: {
      type: Boolean,
      default: true
    },
    length: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    }
  },
  setup() {
    function formatNumber(number) {
      if (typeof number !== 'number') {
        return number;
      }
      return number ? new Intl.NumberFormat('es-CL').format(number) : 0;
    }

    return {
      formatNumber
    };
  }
};
</script>
